/* Advisors page — `.lpv3` redesign (matches landing/reseller styling). */
import { Lpv3Header, Lpv3Footer } from "@/components/Lpv3Chrome";
import { useNavigate } from "react-router-dom";
import { Seo } from "@/components/Seo";
import "./LandingPageV3.css";

const ADVISORS = [
  {
    id: "pradeep-kumar-jain",
    name: "Pradeep Kumar Jain",
    title: "Managing Partner, Singhania & Co.",
    image: "https://singhania.com/img/pradeep-kumar.jpg",
    qualifications: ["M.Sc.", "LL.B. (Hons.)", "CS"],
    expertise: ["Company Laws & M&A", "SEBI/RBI Compliance", "Financial Restructuring", "Takeovers & Mutual Funds"],
    bio: "Mr. Pradeep Jain is the Managing Partner at Singhania & Co. with extensive expertise in company laws, mergers & acquisitions, joint ventures, financial restructuring, and SEBI/RBI/IRDA/FIPB compliance. He advises clients on takeovers, mutual funds, asset management, trusteeship, and foreign institutional investors. A qualified Advocate, Company Secretary, and associate member of the Chartered Institute of Securities & Investments.",
    memberships: ["Bar Council of India", "ICSI", "Bombay High Court", "ASSOCHAM", "TiE", "FICCI"],
    profileUrl: "https://www.singhania.com/profile/pradeep-kumar-jain-11",
  },
];

const AdvisorsPage = () => {
  const navigate = useNavigate();
  return (
    <div className="lpv3" data-testid="advisors-page">
      <Seo
        title="IPO Advisors Marketplace | Merchant Bankers, CAs & Valuers — IPOLabs"
        description="Find and hire SEBI-aligned IPO advisors on IPOLabs — merchant bankers (BRLM), CAs, company secretaries, legal counsel, RTAs and registered valuers."
        path="/advisors"
      />
      <Lpv3Header />

      <div className="hero compact" data-testid="advisors-hero">
        <span className="hero-pill">Board of Advisors</span>
        <div className="hero-h">Our <span className="accent">Advisors</span></div>
        <div className="hero-sub hero-sub-wide">A curated network of industry-leading professionals who guide IPOLabs&apos; strategic direction and ensure the highest standards of regulatory compliance and governance.</div>
      </div>

      <div className="sec">
        {ADVISORS.map((a) => (
          <div className="adv-card" key={a.id} data-testid={`advisor-card-${a.id}`}>
            <img src={a.image} alt={a.name} data-testid={`advisor-image-${a.id}`} />
            <div className="adv-info">
              <div className="adv-top">
                <div>
                  <div className="adv-name" data-testid={`advisor-name-${a.id}`}>{a.name}</div>
                  <div className="adv-title">{a.title}</div>
                </div>
                <a className="adv-link" href={a.profileUrl} target="_blank" rel="noopener noreferrer" data-testid={`advisor-profile-link-${a.id}`}>
                  View Profile <i className="ti ti-external-link" aria-hidden="true" />
                </a>
              </div>
              <p className="adv-bio">{a.bio}</p>
              <div className="adv-cols">
                <div>
                  <div className="adv-grp-h">Qualifications</div>
                  {a.qualifications.map((q) => <span key={q} className="adv-chip">{q}</span>)}
                </div>
                <div>
                  <div className="adv-grp-h">Expertise</div>
                  {a.expertise.map((e) => <span key={e} className="adv-chip">{e}</span>)}
                </div>
                <div>
                  <div className="adv-grp-h">Memberships</div>
                  {a.memberships.map((m) => <span key={m} className="adv-chip">{m}</span>)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="cta" data-testid="advisors-cta">
        <div className="cta-h">Build your IPO advisory team</div>
        <div className="cta-d">Discover and engage verified CAs, CS, legal, auditors, RTAs and bankers on the Advisor Marketplace.</div>
        <div className="hero-btns">
          <button className="btn-dark" onClick={() => navigate("/advisor-marketplace")} data-testid="advisors-cta-marketplace"><i className="ti ti-users" aria-hidden="true" /> Explore Advisor Marketplace</button>
          <button className="btn-line" onClick={() => navigate("/login")} data-testid="advisors-cta-get-started">Get Started</button>
        </div>
      </div>

      <Lpv3Footer />
    </div>
  );
};

export default AdvisorsPage;
